import { css } from "../helpers/webComponents";

const styles: string = css`
  :host {
    background-color:rgb(255, 255, 255);
    border: 30px solid rgb(38, 42, 48);
    border-radius: 30px;
    color: black;
    display: flex;
    flex-direction: column;
    padding: 10px;
    position: fixed;
    z-index: 1;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 33%;
    height: 80%;
    box-sizing: border-box;
  }

  .header {
    font-size: 1.2em;
    margin-bottom: 10px;
    text-align: center;
  }

  .input-container {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  input[type="text"] {
    width: 80%;
    padding: 10px;
    font-size: 1em;
    margin-bottom: 10px;
    border: 2px solid #3B4B62;
    border-radius: 5px;
  }

  button.submit-button {
    padding: 10px 20px;
    font-size: 1em;
    background-color:rgb(121, 128, 139);
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
  }

  button.submit-button:hover {
    background-color:rgb(59, 62, 65);
  }
`;

export class MorsePuzzleComponent extends HTMLElement {
    // The correct answer is the following four words in order.
    private correctOrder: string[] = ["mannequin", "globe", "fireplace", "bookshelf"];

    public constructor() {
        super();
        this.attachShadow({ mode: "open" });
    }

    public connectedCallback(): void {
        this.render();
    }

    /**
   * Called when the user clicks the submit button.
   * It checks the answer in the input field.
   */
    private handleSubmit(): void {
        const inputEl: HTMLInputElement = this.shadowRoot?.querySelector("#morse-input") as HTMLInputElement;
        if (!inputEl) return;
        const answer: string = inputEl.value.trim().toLowerCase();
        // Split the answer on whitespace.
        const answerWords: string[] = answer.split(/\s+/);
        // Check if each word matches the correct order.
        const isCorrect: boolean =
      answerWords.length === this.correctOrder.length &&
      this.correctOrder.every((word, index) => word === answerWords[index]);

        if (isCorrect) {
            // Puzzle solved: dispatch an event so the room can unlock the next room.
            this.dispatchEvent(new CustomEvent("morse-puzzle-solved", { bubbles: true, composed: true }));
            this.style.display = "none";
        }
        else {
            // Provide feedback and clear the input.
            alert("Incorrect answer. Please try again.");
            inputEl.value = "";
        }
    }

    private render(): void {
        if (!this.shadowRoot) return;
        this.shadowRoot.innerHTML = `
      <style>${styles}</style>
      <div class="header">
        Enter the translated Morse code words in the correct order:
      </div>
      <div class="input-container">
        <input type="text" id="morse-input" placeholder="item" />
        <button class="submit-button">Submit</button>
      </div>
    `;
        this.shadowRoot.querySelector("button.submit-button")?.addEventListener("click", () => this.handleSubmit());
    }
}

customElements.define("morse-puzzle", MorsePuzzleComponent);
